import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Ask',
  data() {
    return {
      maxtermId: this.$route.query.maxtermId,
      search: '',
      repeatName: '',
      //判断名字是否重复
      form: {},
      editform: {},
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      rules: {
        askName: [{
          required: true,
          message: '请输入要求名称',
          trigger: 'blur'
        }],
        ifTrue: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      request.get('/ask/list?maxtermId=' + this.maxtermId).then(res => {
        console.log(res);
        this.ticket = res.data;
        if (this.ticket != null) {
          this.total = this.ticket.length;
        } else this.total = 0;
        this.getPageInfo();
      });
    },
    //保持数据
    save(formName) {
      console.log(this.$refs[formName]);
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值 validator: validateSolution_Name,
        console.log("看看");
        if (valid) {
          this.form.maxtermId = this.maxtermId;
          request.get('/ask/save', {
            params: {
              askName: this.form.askName,
              ifTrue: this.form.ifTrue,
              maxtermId: this.maxtermId
            }
          }).then(res => {
            console.log(res.code + res.mag + res.date + "save" + res);
            if (res.code === "0") {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisible = false;
              this.form = {};
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改数据
    edit(formName) {
      //console.log(this.editform.solution_Lock+"--"+this.editform.solution_StatType+"--"+this.editform.solution_Type)
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值
        if (valid) {
          request.get('/ask/update', {
            params: {
              askName: this.editform.askName,
              ifTrue: this.editform.ifTrue,
              askId: this.editform.askId
            }
          }).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "编辑成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisibleEdit = false;
            } else {
              this.$message({
                message: "编辑失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      this.editform = JSON.parse(JSON.stringify(row));
    },
    //删除按钮点击事件
    deleteOne(askId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/ask/delete', askId).then(res => {
          if (res.code === "0") {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    }
  }
};